// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { DemoHasAccessService } from 'app/modules/demodata/services/demo-has-access.service';
import { MON_MODULES } from '@client/ng2/core/constants/mon-modules.constant';

@Component({
    selector: 'document-details-section-dashboard',
    standalone: false,
    template: `
        <div class="document-details-dashboard px-6" *ngIf="!loading">
            <h3 class="font-weight-300 module-title mb-4">
                <span class="mr-2 text-link" [ngClass]="['DOCUMENTDETAILS', 'DASHBOARD'] | monIcons"></span>
                <span translate>Document Dashboard</span>
            </h3>
            <div class="row align-items-stretch">
                <div class="col-48 col-md-24 pb-3" *ngIf="authUser | hasAccess: modules.qa">
                    <div class="card panel-monsido-card mb-0 max-height d-flex flex-column justify-content-between">
                        <div class="card-header py-3">
                            <h2 class="card-title font-weight-300 mt-0">
                                <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'QA'] | monIcons" aria-hidden="true"></span>
                                <span translate>Quality Assurance</span>
                            </h2>
                        </div>
                        <div class="card-body py-0">
                            <page-details-dashboard-charts-qa (onClickHandler)="doCallback($event.params)" [page]="page">
                            </page-details-dashboard-charts-qa>
                        </div>
                        <div class="card-footer text-right bg-white">
                            <a (click)="doCallback({target: 'qa'})" role="button" translate>
                                QUALITY ASSURANCE OVERVIEW
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-48 col-md-24 pb-3" *ngIf="('global_policy' | activeFeature) && (authUser | hasAccess: modules.policies)">
                    <div class="card panel-monsido-card mb-0 max-height d-flex flex-column justify-content-between">
                        <div class="card-header py-3">
                            <h2 class="card-title font-weight-300 mt-0">
                                <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'POLICIES'] | monIcons" aria-hidden="true"></span>
                                <span translate>Content Policy Violations</span>
                            </h2>
                        </div>
                        <div class="card-body">
                            <page-details-dashboard-charts-policies [page]="page"></page-details-dashboard-charts-policies>
                        </div>
                        <div class="card-footer text-right bg-white">
                            <a (click)="doCallback({target: 'policies'})" role="button" translate>
                                POLICIES OVERVIEW
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-48 col-md-24 pb-3" *ngIf="showAccessibility && (authUser | hasAccess: modules.accessibility)">
                    <div class="card panel-monsido-card mb-0 max-height d-flex flex-column justify-content-between">
                        <div class="card-header py-3">
                            <h2 class="card-title font-weight-300 mt-0">
                                <span class="fa-lg fa-fw text-link" [ngClass]="['MENUES', 'ACCESSIBILITY'] | monIcons" aria-hidden="true"></span>
                                <span translate>Accessibility</span>
                            </h2>
                        </div>
                        <div class="card-body">
                            <document-details-dashboard-accessibility [document]="document" *ngIf="hasPdfAccessibilityAccess()">
                            </document-details-dashboard-accessibility>
                            <page-details-dashboard-charts-accessibility [page]="page" *ngIf="!hasPdfAccessibilityAccess()">
                            </page-details-dashboard-charts-accessibility>
                        </div>
                        <div class="card-footer text-right bg-white">
                            <a (click)="doCallback({target: 'accessibility'})" role="button" translate>
                                ACCESSIBILITY OVERVIEW
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card panel-monsido-card mb-0 max-height">
                <div class="card-header py-3">
                    <div class="card-title mt-0">
                        <h2 class="font-weight-300">
                            <span class="fa-lg fa-fw text-link fas fa-info-circle" aria-hidden="true"></span>
                            <span translate>Scan Information</span>
                        </h2>
                    </div>
                </div>
                <div class="card-body pb-1">
                    <div class="row align-items-stretch">
                        <div class="col-16 pb-3">
                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Last Scan' | translate" icon="fas fa-redo">
                                {{ page.lastcheck | userDate:'llll' }}
                            </page-details-section-dashboard-blocks-overview>
                        </div>
                        <div class="col-16 pb-3">
                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Robot Info' | translate" icon="fas fa-robot">
                                <span [ngClass]="{ 'text-danger': page.no_index }">
                                    {{ (!page.no_index ? 'Index' : 'No index') | translate }}
                                </span>
                            </page-details-section-dashboard-blocks-overview>
                        </div>
                        <div class="col-16 pb-3">
                            <page-details-section-dashboard-blocks-overview
                                [infoHeading]="'Language Detected' | translate"
                                icon="fas fa-language"
                                [ngbTooltip]="'Indicates which language this page will be scanned in. Click underneath to change' | translate">
                                <span *ngIf="!showLanguageForm"
                                      class="language-editable"
                                      (click)="showLanguageForm = !showLanguageForm">
                                    {{ getLanguageName() }}
                                </span>
                                <div class="d-flex flex-wrap align-items-center"
                                     (clickOutside)="showLanguageForm = false"
                                     *ngIf="showLanguageForm">
                                    <div class="pr-1">
                                        <select name="language" [(ngModel)]="page.language">
                                            <option [ngValue]="language.code" *ngFor="let language of languages; trackBy: trackByIndex">
                                                {{language.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="pr-1">
                                        <button type="button" class="btn btn-border-radius btn-secondary"
                                                (click)="onUpdatePage()">
                                            <span class="fa fa-check"></span>
                                        </button>
                                    </div>
                                    <div>
                                        <button type="button" (click)="showLanguageForm = !showLanguageForm"
                                                class="btn btn-border-radius btn-inverse">
                                            <span class="fa fa-times"></span>
                                        </button>
                                    </div>
                                </div>
                            </page-details-section-dashboard-blocks-overview>
                        </div>
                        <div class="col-16 pb-3">
                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Document first detected' | translate" icon="fas fa-clock">
                                {{ page.created_at | userDate:'llll' }}
                            </page-details-section-dashboard-blocks-overview>
                        </div>
                        <div class="col-16 pb-3">
                            <page-details-section-dashboard-blocks-overview [infoHeading]="'Word count' | translate" icon="fas fa-font">
                                {{ page.readability_words_count }}
                            </page-details-section-dashboard-blocks-overview>
                        </div>
                        <div class="col-16 pb-3" *ngIf="'readability' | domainActiveFeature">
                            <page-details-section-dashboard-blocks-overview
                                [infoHeading]="'Readability score' | translate"
                                [icon]="['SIDEMENUES', 'QA', 'READABILITY'] | monIcons">
                                <span class="readability-score">
                                    {{ (page.readability || 0) | monNumber }}
                                </span>
                                {{page.readability_level | translateReadability:domain.features.readability_test}}
                            </page-details-section-dashboard-blocks-overview>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class DocumentDetailsSectionDashboardComponent implements OnInit {
    @Input() page: any;
    @Input() document: any;
    @Input() languages: any;
    @Output() callback = new EventEmitter<any>();
    @Output() updatePage = new EventEmitter<any>();

    showLanguageForm: boolean = false;
    showStatistics: boolean = false;
    showAccessibility: boolean = false;
    modules: any = MON_MODULES;
    authUser: any = null;
    loading: boolean = true;
    domain: any;

    constructor (
        private sessionService: SessionService,
        private translateService: TranslateService,
        private loginService: LoginService,
        private demoHasAccessService: DemoHasAccessService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.showLanguageForm = false;
        this.page = this.page || {};
        this.showStatistics = false;
        this.showAccessibility = false;
        this.modules = MON_MODULES;
        this.authUser = null;
        this.loading = true;
        this.domain = this.sessionService.domain;

        this.loginService
            .getUser()
            .then((user: any) => {
                this.loading = false;
                this.authUser = user === null ? this.sessionService.me : user;
            }, () => {})
            .finally(() => {
                if (this.sessionService.domain !== null) {
                    this.showStatistics = Boolean(this.sessionService.domain.features.statistics);
                    this.showAccessibility = Boolean(this.sessionService.domain.features.accessibility);
                }
            });
    }

    doCallback (params: any): void {
        this.callback.emit(params);
    }

    onUpdatePage (): void {
        this.showLanguageForm = false;
        this.updatePage.emit(this.page);
    }

    getLanguageName (): string {
        if (this.page.language === null) {
            return this.translateService.getString('NA');
        }

        const index = this.languages.findIndex((language: any) => {
            return language.code === this.page.language;
        });

        if (index === -1) {
            return this.translateService.getString('NA');
        }

        return this.languages[index].name;
    }

    hasPdfAccessibilityAccess (): boolean {
        const hasPdfAccessibility = Boolean(this.sessionService.customer && this.sessionService.customer.plan_traits.clarity_pdf_accessibility);
        return this.demoHasAccessService.canAccessAccessibilityPDF() || hasPdfAccessibility;
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
